module.exports = __webpack_public_path__ + "img/tof_yes.7ad10990.png";